<ng-container *transloco="let t; read: 'accounts'">
<div class="rounded-lg fixActionRow" id="superFeatureDialog">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ modalTitle }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-1 gap-10 py-5 px-2" [formGroup]="featureGroupForm">

      @if (!hasChosenSuperFeature) {
        <div class="col-span-1">
          <drdp-add-edit-table [dataSource]="uncategorizedDataSource"
            [tableData]="uncategorizedTableData"
            [columns]="addUncategorizedSubColumns"
            (addActionItem)="addSuperFeature($event)">
          </drdp-add-edit-table>
        </div>
      }

      @if (hasChosenSuperFeature) {
        <div class="col-span-1">
          <div>
            <h3 class="global-font-bold">{{ t('features.currentSubFeatures') }}</h3>
            <drdp-add-edit-table [dataSource]="newSubDataSource"
              [tableData]="newSubTableData"
              [columns]="removeUncategorizedSubColumns"
              (deleteActionItem)="removeSubFeature($event)">
            </drdp-add-edit-table>
          </div>
          <div>
            <h3 class="global-font-bold">{{ t('features.addSubFeatures') }}</h3>
            <drdp-add-edit-table [dataSource]="uncategorizedDataSource"
              [tableData]="uncategorizedTableData"
              [columns]="addUncategorizedSubColumns"
              (addActionItem)="addSubFeature($event)">
            </drdp-add-edit-table>
          </div>
        </div>
      }

    </form>

  </div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <button mat-button mat-dialog-close>{{ t('common.cancel') }}</button>
    @if (featureGroupForm.valid) {
      <drdp-btn mat-button [mat-dialog-close]="onSubmit()" [disabled]="false" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
    @if (!featureGroupForm.valid) {
      <drdp-btn mat-button [disabled]="true" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
  </div>
</div>
</ng-container>

